module.exports = __webpack_public_path__ + "static/media/slide-12.c1377989.png";